var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSql(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #21bbee;\n      }\n\n      .cls-3 {\n        fill: #eaf7fd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -1.9,
    y: -2.1,
    width: 87.8,
    height: 99.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4803.7-375.5h2500v2500h-2500V-375.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.3,89.3c-7.6-.5-15.3-2.5-19.9-5.1-2.6-1.5-4.7-3.3-5.4-4.9l-.4-1V18.2l.4-.8c1.7-3.3,6.9-6.4,14.4-8.3,2.5-.6,6.2-1.2,9.1-1.6,3-.4,11.1-.3,14.1,0,8,1,14.9,3.1,19.1,5.9,1.6,1.1,3.3,2.8,3.9,4l.5,1.1v60.1l-.4.8c-.2.4-.9,1.3-1.4,1.9-3.5,3.7-11,6.5-20.9,7.6-2,.3-10.7.4-12.8.3h0ZM50.4,63.5s-1.1-1.1-2.5-2.3-2.5-2.2-2.6-2.3.2-.3.5-.5,1.1-.9,1.7-1.4c1.5-1.6,2.2-3.5,2.2-6.1s-.8-4.5-2.3-6.1c-1.6-1.6-3.3-2.2-5.9-2.2-4,0-7,2.3-8,6.1-.4,1.3-.4,3.9,0,5,.9,3,3.3,5.2,6.2,5.6,1,.2,1.1.3,1.8,1,.4.4,1.2,1.3,1.8,2l1.1,1.1h3c1.7,0,3,0,2.9-.2h0v.2ZM40.2,55.2c-.7-.4-1-.7-1.4-1.5-.4-.6-.4-1-.4-2.5s0-1.8.4-2.5c.5-1.1,1.3-1.6,2.5-1.7,1.6,0,2.5.7,3,2.5.6,2.3,0,4.7-1.5,5.6-.7.4-1.8.4-2.5,0h0ZM27,59.5c3.1-.6,4.9-2.4,4.9-5s-1.1-3.7-4.3-5.1c-1.8-.8-2.5-1.3-2.5-1.9s.6-1.1,1.3-1.1c.7-.2,2.5.2,3.7.6l1,.4v-4.1l-1-.3c-.6-.2-1.9-.3-3.4-.2-2.1,0-2.5,0-3.3.4-2.3.9-3.4,2.5-3.4,4.8s1.1,3.6,4.1,4.8c1.8.7,2.4,1.3,2.4,1.9,0,1.4-2.4,1.6-4.8.4-.7-.4-1.3-.6-1.3-.7s0,1,0,2.1q0,2.2.4,2.4c1.5.5,4.7.8,6.5.5l-.2.2ZM62.7,57.4v-1.8h-5.6v-12.7h-5v16.4h10.6v-1.8h0ZM45.3,25c4.9-.4,8.7-1,12-2.1,3.3-1.1,5.2-2.4,5.6-3.9.2-.5.2-.8,0-1.4-1.1-2.7-6.9-4.8-15.7-5.6-3.8-.4-10.7-.3-14.3.3-5.5.7-10,2.1-12,3.7-4,3.2.3,6.7,10.1,8.3,4.3.7,9.8,1,14.4.6h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSql);
export default __webpack_public_path__ + "static/media/SQL.578f1b53120a9c9e343c04b1724fc10b.svg";
export { ForwardRef as ReactComponent };